import { render, staticRenderFns } from "./DoctorSocials.vue?vue&type=template&id=1a9803fe&"
import script from "./DoctorSocials.vue?vue&type=script&lang=js&"
export * from "./DoctorSocials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports